/* Adorned by Lior - phone product page helper (2026-10-01). Loaded only by sections/main-product.liquid.
   Phones (<750px): moves the quantity box into the theme's own Add-to-cart row
   (.product-form__quantity-and-btn) so "- 1 +" and Add to cart share one line. Puts it back in its
   original spot when the screen gets wider (rotation), so tablet/desktop never change.
   The quantity input keeps form="product-form-..." so the main button and the sticky bar still send it. */
(function () {
  'use strict';
  if (window.__liorPdpMobile) return;
  window.__liorPdpMobile = true;

  var mq = window.matchMedia('(max-width: 749px)');
  var home = null; // comment node marking the quantity box's original spot
  var raf = 0;

  function parts() {
    var info = document.querySelector('product-info.main-product__info-container');
    if (!info) return null;
    var qty = info.querySelector('.product-form__quantity[id^="Quantity-Form-"]');
    var row = info.querySelector('product-form.main-product-form .product-form__quantity-and-btn');
    var btn = row && row.querySelector('.product-form__submit');
    return qty && row && btn ? { qty: qty, row: row, btn: btn } : null;
  }

  function place() {
    var p = parts();
    if (!p) return;
    // the inline script in main-product.liquid usually moves the box during page load; adopt its marker
    if ((!home || !home.parentNode) && window.__liorQtyHome && window.__liorQtyHome.parentNode) home = window.__liorQtyHome;
    if (mq.matches) {
      if (p.qty.parentNode !== p.row) {
        if (!home || !home.parentNode) {
          home = document.createComment('lior-qty-home');
          p.qty.parentNode.insertBefore(home, p.qty);
        }
        p.row.insertBefore(p.qty, p.btn);
      }
      if (!p.row.classList.contains('lior-qty-row')) {
        p.row.classList.add('lior-qty-row', 'product-form__quantity-and-btn--stretch-quantity');
      }
    } else {
      if (p.qty.parentNode === p.row && home && home.parentNode) {
        home.parentNode.insertBefore(p.qty, home);
      }
      p.row.classList.remove('lior-qty-row', 'product-form__quantity-and-btn--stretch-quantity');
    }
  }

  function schedule() {
    if (raf) return;
    raf = window.requestAnimationFrame(function () {
      raf = 0;
      try { place(); } catch (e) {}
    });
  }

  function init() {
    try { place(); } catch (e) {}
    try {
      if (mq.addEventListener) mq.addEventListener('change', schedule);
      else if (mq.addListener) mq.addListener(schedule);
      // variant changes / theme-editor reloads can swap nodes: re-apply when the product column changes
      var info = document.querySelector('product-info.main-product__info-container');
      if (info && window.MutationObserver) {
        new MutationObserver(function () { if (mq.matches) schedule(); }).observe(info, { childList: true, subtree: true });
      }
      document.addEventListener('shopify:section:load', schedule);
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
